import { Arab2Chn } from './Arab2Chn'
import { fillzero } from './fillzero'
import number2DateTime from './momentTime'
export default {
  Arab2Chn,
  fillzero,
  number2DateTime
}



// WEBPACK FOOTER //
// ./src/js/filters/index.js